export enum ProfileRole {
    ADMIN,
    ANON,
    CLIENT,
    CONTENT_MANAGER,
    LAWYER,
    BOT
}